import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedAsterisk = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7050_13941)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M7 2.1875V11.8125",
				stroke: "#B40030",
				strokeWidth: .875,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.625 4.375L11.375 9.625",
				stroke: "#B40030",
				strokeWidth: .875,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.625 9.625L11.375 4.375",
				stroke: "#B40030",
				strokeWidth: .875,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7050_13941",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
export default SvgRedAsterisk;
